import { render, staticRenderFns } from "./AlterarDadosRecepcionista.vue?vue&type=template&id=5adadc8b"
import script from "./AlterarDadosRecepcionista.vue?vue&type=script&lang=js"
export * from "./AlterarDadosRecepcionista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports